import React from 'react'
import { Link } from 'react-router-dom'
import './Terms.css'

const Terms = () => {
  return (
    <div dir="rtl" className="terms-page">
      <div className="terms-container">
        <Link to="/" className="terms-back-link">
          <span className="terms-back-arrow" aria-hidden>←</span>
          חזרה לדף הבית
        </Link>

        <header className="terms-header">
          <h1 className="terms-title">תנאי שימוש</h1>
          <p className="terms-subtitle">Donna</p>
          <span className="terms-updated">עדכון אחרון: 9 בפברואר 2026</span>
        </header>

        <div className="terms-intro">
          <p>
            ברוכים הבאים ל-Donna AI (&quot;Donna&quot;, &quot;אנחנו&quot;, &quot;שלנו&quot;, או &quot;אנו&quot;), עוזרת אישית מבוססת בינה מלאכותית הזמינה דרך WhatsApp וממשקי אינטרנט קשורים. תנאי שימוש אלה (&quot;תנאים&quot;) מסדירים את השימוש שלכם בשירותי Donna AI.
          </p>
          <p>על ידי שימוש ב-Donna AI, אתם מסכימים לתנאים אלה. אם אינכם מסכימים לתנאים אלה, אנא אל תשתמשו בשירות.</p>
        </div>

        <article className="terms-content">
          <section id="acceptance" className="terms-section">
            <h2>1. קבלת התנאים</h2>
            <p>על ידי גישה לשירותי Donna AI או שימוש בהם, אתם מסכימים להיות כפופים לתנאי שימוש אלה. אם אינכם מסכימים לחלק כלשהו מהתנאים, אין לכם רשות לגשת לשירות או להשתמש בו.</p>
            <p>אנו שומרים לעצמנו את הזכות לעדכן, לשנות או להחליף כל חלק מתנאים אלה בכל עת. המשך השימוש בשירות לאחר פרסום שינויים מהווה הסכמה לשינויים אלה.</p>
          </section>

          <section id="service-description" className="terms-section">
            <h2>2. תיאור השירות</h2>
            <p>Donna AI היא עוזרת אישית מבוססת בינה מלאכותית המסייעת למשתמשים בניהול:</p>
            <ul>
              <li>יומן ופגישות (Google Calendar)</li>
              <li>משימות ותזכורות</li>
              <li>ניהול אימיילים (Gmail)</li>
              <li>חיפוש וניהול קבצים ב-Google Workspace</li>
              <li>אחסון והחזרת מידע אישי (&quot;זיכרון&quot; או &quot;מוח שני&quot;)</li>
            </ul>
            <p>השירות זמין דרך WhatsApp וממשקי אינטרנט קשורים. אנו שומרים לעצמנו את הזכות לשנות, להשעות או להפסיק כל חלק מהשירות בכל עת, ללא הודעה מוקדמת.</p>
          </section>

          <section id="user-accounts" className="terms-section">
            <h2>3. חשבונות משתמשים</h2>
            <h3>3.1 יצירת חשבון</h3>
            <p>כדי להשתמש בשירות, ייתכן שתצטרכו ליצור חשבון. אתם מסכימים לספק מידע מדויק, עדכני ומלא בעת יצירת החשבון.</p>
            
            <h3>3.2 אחריות לחשבון</h3>
            <p>אתם אחראים לשמירה על סודיות פרטי החשבון והסיסמה שלכם. אתם מסכימים להודיע לנו מיד על כל שימוש לא מורשה בחשבון שלכם.</p>
            
            <h3>3.3 חיבורים לשירותים חיצוניים</h3>
            <p>השירות מאפשר חיבור לשירותים חיצוניים כמו Google Calendar ו-Gmail. חיבורים אלה דורשים הרשאה מפורשת שלכם וניתן לבטל אותם בכל עת. אתם מסכימים שאנו ניגש לנתונים משירותים אלה רק כדי לבצע את הפעולות שביקשתם.</p>
          </section>

          <section id="acceptable-use" className="terms-section">
            <h2>4. שימוש מותר</h2>
            <p>אתם מסכימים להשתמש בשירות רק למטרות חוקיות ובאופן התואם את תנאים אלה. אסור לכם:</p>
            <ul>
              <li>להשתמש בשירות באופן העלול לפגוע, להשבית, להפריע או להזיק לשירות או למשתמשים אחרים</li>
              <li>לנסות לגשת ללא הרשאה לחלקים מוגנים של השירות</li>
              <li>להשתמש בשירות להעברת תוכן מזיק, ויראלי או זדוני</li>
              <li>להשתמש בשירות להפרת זכויות קניין רוחני של אחרים</li>
              <li>להשתמש בשירות להעברת הודעות ספאם, דואר זבל או תקשורת מסחרית לא רצויה</li>
              <li>להשתמש בשירות באופן העלול להפר חוקים או תקנות מקומיים, מדינתיים, לאומיים או בינלאומיים</li>
            </ul>
          </section>

          <section id="ai-limitations" className="terms-section">
            <h2>5. מגבלות בינה מלאכותית</h2>
            <p>Donna AI משתמשת בבינה מלאכותית כדי להבין ולבצע בקשות. עם זאת, חשוב להבין:</p>
            <ul>
              <li>השירות אינו מושלם ועלול לעשות טעויות</li>
              <li>תוצאות הבינה המלאכותית עשויות להיות לא מדויקות או לא מתאימות</li>
              <li>אתם אחראים לבדוק ולאמת את הפעולות שבוצעו על ידי השירות</li>
              <li>אנו לא נושאים באחריות לנזקים הנובעים מטעויות או אי-דיוקים של הבינה המלאכותית</li>
            </ul>
            <p>אנו ממליצים לבדוק פעולות חשובות (כמו שליחת אימיילים או יצירת אירועים) לפני אישורן.</p>
          </section>

          <section id="intellectual-property" className="terms-section">
            <h2>6. קניין רוחני</h2>
            <h3>6.1 זכויותינו</h3>
            <p>כל הזכויות, הזכויות והאינטרסים בשירות, כולל אך לא רק קוד, עיצוב, לוגו, טקסטים ותוכן אחר, שייכים לנו או למתמחים שלנו.</p>
            
            <h3>6.2 תוכן המשתמש</h3>
            <p>אתם שומרים על כל הזכויות בתוכן שאתם מספקים ל-Donna AI (הודעות, משימות, הערות וכו'). על ידי שימוש בשירות, אתם מעניקים לנו רישיון להשתמש בתוכן זה רק כדי לספק ולשפר את השירות.</p>
          </section>

          <section id="privacy" className="terms-section">
            <h2>7. פרטיות</h2>
            <p>השימוש שלכם ב-Donna AI כפוף למדיניות הפרטיות שלנו, המסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע שלכם. אנא קראו את <Link to="/privacy">מדיניות הפרטיות</Link> שלנו כדי להבין את הפרקטיקות שלנו.</p>
          </section>

          <section id="third-party-services" className="terms-section">
            <h2>8. שירותים של צדדים שלישיים</h2>
            <p>השירות עשוי להשתמש או להכיל שירותים של צדדים שלישיים (כמו WhatsApp, Google Calendar, Gmail). השימוש בשירותים אלה כפוף לתנאי השימוש ומדיניות הפרטיות שלהם. אנו לא נושאים באחריות לפעולות או מדיניות של צדדים שלישיים אלה.</p>
          </section>

          <section id="service-availability" className="terms-section">
            <h2>9. זמינות השירות</h2>
            <p>אנו שואפים לספק שירות זמין ואמין, אך איננו יכולים להבטיח שהשירות יהיה זמין ללא הפרעות. השירות עשוי להיות מושעה או מוגבל עקב:</p>
            <ul>
              <li>תחזוקה מתוכננת או לא מתוכננת</li>
              <li>כשלים טכניים</li>
              <li>אירועים מחוץ לשליטתנו</li>
              <li>שימוש לרעה או פעילות חשודה</li>
            </ul>
            <p>אנו לא נושאים באחריות לכל נזק או אובדן הנובעים מאי-זמינות השירות.</p>
          </section>

          <section id="limitation-liability" className="terms-section">
            <h2>10. הגבלת אחריות</h2>
            <p>במידה המרבית המותרת על פי החוק:</p>
            <ul>
              <li>השירות מסופק &quot;כפי שהוא&quot; ו&quot;כפי שזמין&quot; ללא כל אחריות, מפורשת או משתמעת</li>
              <li>אנו לא נושאים באחריות לכל נזק ישיר, עקיף, מקרי, מיוחד או תוצאתי הנובע מהשימוש או אי-היכולת להשתמש בשירות</li>
              <li>אחריותנו הכוללת תחת תנאים אלה מוגבלת לסכום ששילמתם לנו עבור השירות במהלך 12 החודשים האחרונים</li>
            </ul>
          </section>

          <section id="indemnification" className="terms-section">
            <h2>11. פיצוי</h2>
            <p>אתם מסכימים לפצות, להגן ולשחרר אותנו מכל תביעות, נזקים, אחריות, הוצאות והפסדים (כולל שכר טרחה משפטי) הנובעים מהשימוש שלכם בשירות, הפרת תנאים אלה, או הפרת זכויות של אחרים.</p>
          </section>

          <section id="termination" className="terms-section">
            <h2>12. סיום</h2>
            <h3>12.1 סיום על ידיכם</h3>
            <p>אתם רשאים להפסיק את השימוש בשירות בכל עת על ידי מחיקת החשבון שלכם או הפסקת השימוש בשירות.</p>
            
            <h3>12.2 סיום על ידינו</h3>
            <p>אנו שומרים לעצמנו את הזכות להשעות או לסיים את הגישה שלכם לשירות בכל עת, ללא הודעה מוקדמת, מסיבות כוללות אך לא רק:</p>
            <ul>
              <li>הפרת תנאים אלה</li>
              <li>שימוש לרעה או פעילות חשודה</li>
              <li>דרישות משפטיות או רגולטוריות</li>
              <li>הפסקת השירות</li>
            </ul>
          </section>

          <section id="changes" className="terms-section">
            <h2>13. שינויים בתנאים</h2>
            <p>אנו שומרים לעצמנו את הזכות לעדכן או לשנות תנאים אלה בכל עת. שינויים מהותיים יפורסמו בדף זה עם תאריך עדכון מעודכן. המשך השימוש בשירות לאחר שינויים מהותיים מהווה הסכמה לתנאים המעודכנים.</p>
          </section>

          <section id="governing-law" className="terms-section">
            <h2>14. דין שולט</h2>
            <p>תנאים אלה נשלטים על ידי חוקי מדינת ישראל, ללא קשר לעקרונות התנגשות החוקים. כל מחלוקת הנובעת מתנאים אלה תיפתר בבתי המשפט המוסמכים בישראל.</p>
          </section>

          <section id="contact" className="terms-section terms-contact-section">
            <h2>15. פרטי יצירת קשר</h2>
            <p>לשאלות או בקשות הקשורות לתנאי שימוש אלה, אנא צרו איתנו קשר:</p>
            <div className="terms-contact-box">
              <p><strong>אימייל:</strong> <a href="mailto:donnai.help@gmail.com">donnai.help@gmail.com</a></p>
              <p><strong>טלפון:</strong> <a href="tel:+972543911602">054-391-1602</a></p>
              <p><strong>אתר:</strong> <a href="https://donnai.io" target="_blank" rel="noopener noreferrer">https://donnai.io</a></p>
            </div>
          </section>
        </article>
      </div>
    </div>
  )
}

export default Terms

